import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

const latestImages = [
  'https://readdy.ai/api/search-image?query=Editorial%20minimal%20photograph%20with%20warm%20neutral%20tones%2C%20soft%20natural%20lighting%2C%20clean%20simple%20composition%2C%20modern%20aesthetic%2C%20subtle%20texture%2C%20atmospheric%20mood%2C%20no%20text%2C%20elegant%20minimal%20style%2C%20professional%20photography&width=600&height=375&seq=latest-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Minimal%20editorial%20scene%20with%20soft%20golden%20hour%20lighting%2C%20warm%20peach%20and%20cream%20tones%2C%20clean%20modern%20composition%2C%20simple%20elegant%20aesthetic%2C%20atmospheric%20photography%2C%20subtle%20depth%20of%20field%2C%20professional%20studio%20quality&width=600&height=375&seq=latest-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20ambient%20interior%20photograph%20with%20soft%20diffused%20lighting%2C%20clean%20minimal%20surfaces%2C%20neutral%20beige%20and%20warm%20gray%20palette%2C%20modern%20aesthetic%2C%20atmospheric%20mood%2C%20professional%20product%20photography%20style%2C%20elegant%20composition&width=600&height=375&seq=latest-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Artistic%20abstract%20photograph%20with%20warm%20coral%20and%20amber%20gradients%2C%20soft%20flowing%20forms%2C%20minimal%20modern%20composition%2C%20gentle%20light%20play%2C%20atmospheric%20texture%2C%20professional%20fine%20art%20style%2C%20clean%20background&width=600&height=375&seq=latest-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Soft%20editorial%20still%20life%20with%20warm%20natural%20lighting%2C%20neutral%20textures%2C%20minimal%20modern%20aesthetic%2C%20clean%20composition%2C%20elegant%20shadows%2C%20professional%20photography%2C%20atmospheric%20mood%2C%20simple%20background&width=600&height=375&seq=latest-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20photograph%20with%20organic%20textures%2C%20soft%20natural%20light%2C%20minimal%20modern%20design%2C%20neutral%20beige%20palette%2C%20atmospheric%20composition%2C%20professional%20art%20photography%2C%20clean%20elegant%20style&width=600&height=375&seq=latest-06&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Minimal%20photograph%20with%20warm%20sunset%20tones%2C%20soft%20gradient%20background%2C%20clean%20modern%20aesthetic%2C%20atmospheric%20lighting%2C%20professional%20editorial%20style%2C%20subtle%20textures%2C%20elegant%20simple%20composition&width=600&height=375&seq=latest-07&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Artistic%20photograph%20with%20warm%20golden%20and%20coral%20accents%2C%20soft%20dreamy%20atmosphere%2C%20minimal%20modern%20composition%2C%20professional%20fine%20art%20style%2C%20clean%20background%2C%20gentle%20light%20diffusion%2C%20elegant%20mood&width=600&height=375&seq=latest-08&orientation=landscape',
];

export default function LatestArticles() {
  const latestArticles = getLatestArticles(8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-2">
              Latest Updates
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              最新<span className="text-secondary-500">爆料</span>
            </h2>
          </div>
          <Link
            to="/category/chigua-qianxian"
            className="hidden md:inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {latestArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group cursor-pointer"
            >
              <article className="bg-background-50 rounded-2xl overflow-hidden hover:bg-background-50 transition-colors h-full flex flex-col">
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={latestImages[index]}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`今日看料 - ${article.title}`}
                  />
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-primary-600 font-medium bg-primary-100 px-2 py-0.5 rounded">
                      {article.categoryName}
                    </span>
                    {article.isHot && (
                      <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2 py-0.5 rounded flex items-center gap-0.5">
                        <i className="ri-fire-line text-[10px]"></i>热
                      </span>
                    )}
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors flex-1">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                    {article.summary}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-500 pt-3 border-t border-background-200/70">
                    <span>{article.publishDate}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.viewCount > 10000
                        ? `${(article.viewCount / 10000).toFixed(1)}万阅读`
                        : `${article.viewCount}阅读`}
                    </span>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>

        <div className="mt-6 flex justify-center lg:hidden">
          <Link
            to="/category/chigua-qianxian"
            className="px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部爆料 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}